import styled, { css } from 'styled-components';
import { withProp } from 'styled-tools';
import { media, mediaQuery } from '../../../common/styles/styleUtil';
import leftArrow from './assets/arrow_left.png';
import leftArrowHover from './assets/arrow_left_hover.png';
import rightArrow from './assets/arrow_right.png';
import rightArrowHover from './assets/arrow_right_hover.png';

export const CarouselWrapper = styled.div`
  ${media.xs`
    display: none;
  `};
  margin: 32px auto;
  position: relative;
  border: solid 1px #e9ebed;
  .carousel {
    position: relative;
  }

  .slick-slider {
    .slick-list {
      .slick-slide {
        padding: 0;
        margin: 0;
      }
    }
    .slick-arrow {
      border-radius: 0;
      background-color: unset;
      box-shadow: none;
      position: absolute;
      width: 40px;
      height: 40px;
      z-index: 1;
      top: calc(46% + 10px);
      &.slick-disabled {
        opacity: 0;
        cursor: default;
      }
      &.slick-next {
        right: 10px;
        &:before {
          content: url('${rightArrow}');
          margin-right: 12px;
          text-indent: 4px;
        }
        &.slick-next-hover {
          &:before {
            content: url('${rightArrowHover}');
            margin-right: 12px;
            text-indent: 4px;
          }
        }
      }
      &.slick-next:not(.slick-disabled) {
        &:hover::before {
          content: url('${rightArrowHover}');
          height: 40px;
        }
      }
      &.slick-prev {
        left: 10px;
        &:before {
          content: url('${leftArrow}');
          margin-right: 12px;
          text-indent: 4px;
        }
        &.slick-prev-hover {
          &:before {
            content: url('${leftArrowHover}');
            margin-right: 12px;
            text-indent: 4px;
          }
        }
      }
      &.slick-prev:not(.slick-disabled) {
        &:hover::before {
          content: url('${leftArrowHover}');
          height: 40px;
        }
      }
      &:hover:not(.slick-disabled) {
        opacity: 1;
      }
      ${withProp(
        ['isOnContentPage', 'isOnPovPage'],
        (isOnContentPage, isOnPovPage) =>
          (isOnContentPage || isOnPovPage) &&
          css`
            top: 220px;
            width: 40px;
            border-radius: 0;
            box-shadow: none;
          `,
      )}
      ${media.xs`
        display: none !important;
      `}
    };
  }
 }
`;

export const CarouselCounter = styled.div`
  display: flex;
  align-items: center;
  width: 70px;
  height: 29px;
  padding: 6px 8px;
  position: absolute;
  right: 0;
  top: 92%;
  font-size: 11px;
  font-weight: 500;
  text-align: left;
  letter-spacing: 1px;
  color: #ffffff;
  border-radius: 2px 0 0 2px;
  background-color: rgba(51, 63, 72, 0.6);
`;

export const ImageCaption = styled.div`
  display: block;
  width: 100%;
  height: auto;
  padding: 24px;
  @media (${mediaQuery.tablet}) {
    width: 100%;
    font-size: 16px;
  }
  p {
    margin: 0;
    font-size: 18px;
    font-weight: 300;
    color: #697684;
    line-height: normal;
    word-break: break-word;
  }
`;
